import {
   REPORT_SALES_DETAIL,
   REPORT_PURCHASE_DETAIL,
   REPORT_OUTSTANDING_DETAIL,
   REPORT_STOCK_DETAIL,
   REPORT_PURCHASE_SUMMARY,
   REPORT_TDS,
   REPORT_LEDGER,
   REPORT_SALE_SUMMARY,
   REPORT_ITEM_BY_CONTACT,
   REPORT_INVENTORY_DETAIL,
   CLEAR_CACHE_REPORT,
   REPORT_BILL_TO_BILL,
   REPORT_NONE_SERIALISED_PROFIT,
   REPORT_TRIAL_BALANCE,
   REPORT_TRIAL_BALANCE_GLGROUP_WISE,
   REPORT_TRIAL_BALANCE_FULL,
   REPORT_BALANCE_SHEET,
   REPORT_BALANCE_SHEET_SUMMARY,
   REPORT_SERIALWISE_HISTORY,
   REPORT_BALANCE_SHEET_VERTICAL,
   REPORT_PROFIT_LOSS_MONTHLY,
   REPORT_STORE_STOCK,
   REPORT_STORE_STOCK_FOR_RECEIVE,
   REPORT_B2B_SALES,
   REPORT_B2CL_SALES,
   REPORT_B2CS_SALES,
   REPORT_CDNR_SALES,
   REPORT_CDNUR_SALES,
   REPORT_EXP_SALES,
   REPORT_EXEMP_SALES,
   REPORT_HSNB2B_SALES,
   REPORT_HSNB2C_SALES,
   REPORT_DOC_SALES,
   REPORT_GSTR3B,
   REPORT_FORMAT,
   UPDATE_REPORT_FORMAT,
   ADD_REPORT_FORMAT,
   DELETE_REPORT_FORMAT,
   REPORT_ALL_TRANSACTION,
   GSTR_2AB2B_RECONCILATION,
   REPORT_PURCHASE_ORDER_DETAIL,
   REPORT_PURCHASE_CHALLAN_DETAIL,
   REPORT_SALE_ORDER_DETAIL,
   REPORT_SALE_CHALLAN_DETAIL,
   REPORT_MILL_ISSUE_DETAIL,
   REPORT_GRAY_PURCHASE_DETAIL,
   REPORT_STATEMENT,
   REPORT_OUTSTANDING,
} from '../types';

const initialState = {
   list: [],
   single: null,
   stock: [],
   purchaseDetail: [],
   purchaseOrderDetail: [],
   saleSummary: [],
   purchaseSummary: [],
   tds: [],
   ledger: [],
   itemByContact: [],
   outstanding: [],
   billToBillProfit: [],
   GSTR2AB2BReconcilation: [],
};

const reducer = (state = initialState, action) => {
   const { type, payload } = action;

   switch (type) {
      case REPORT_SALES_DETAIL:
         return { ...state, list: payload };

      case REPORT_SALE_ORDER_DETAIL:
         return { ...state, saleOrderDetail: payload || [] };

      case REPORT_SALE_CHALLAN_DETAIL:
         return { ...state, saleChallanDetail: payload || [] };

      case REPORT_STOCK_DETAIL:
         return { ...state, stock: payload };

      case REPORT_PURCHASE_DETAIL:
         return { ...state, purchaseDetail: payload };

      case REPORT_PURCHASE_ORDER_DETAIL:
         return { ...state, purchaseOrderDetail: payload || [] };

      case REPORT_PURCHASE_CHALLAN_DETAIL:
         return { ...state, purchaseChallanDetail: payload || [] };

      case REPORT_SALE_SUMMARY:
         return { ...state, saleSummary: payload };

      case REPORT_PURCHASE_SUMMARY:
         return { ...state, purchaseSummary: payload };

      case REPORT_TDS:
         return { ...state, tds: payload };

      case REPORT_LEDGER:
         return { ...state, ledger: payload };

      case REPORT_STATEMENT:
         return { ...state, statement: payload };

      case REPORT_ITEM_BY_CONTACT:
         return { ...state, itemByContact: payload };

      case REPORT_INVENTORY_DETAIL:
         return { ...state, inventoryDetail: payload };

      case REPORT_OUTSTANDING_DETAIL:
         return { ...state, outstanding: payload };

      case REPORT_OUTSTANDING:
         return { ...state, outstandingReport: payload };

      case REPORT_BILL_TO_BILL:
         return { ...state, billToBillProfit: payload };

      case REPORT_NONE_SERIALISED_PROFIT:
         return { ...state, noneSerialisedProfit: payload };

      case REPORT_SERIALWISE_HISTORY:
         return { ...state, serialWiseHistory: payload };

      case CLEAR_CACHE_REPORT:
         return {
            ...state,
            stock: [],
            outstanding: [],
            inventoryDetail: [],
            ledger: [],
            billToBillProfit: [],
         };

      case REPORT_TRIAL_BALANCE_FULL:
         return { ...state, trialBalanceFull: payload };

      case REPORT_TRIAL_BALANCE_GLGROUP_WISE:
         return { ...state, trialBalanceGlGroupWise: payload };

      case REPORT_TRIAL_BALANCE:
         return { ...state, trialBalance: payload };

      case REPORT_BALANCE_SHEET:
         return { ...state, balanceSheet: payload };

      case REPORT_BALANCE_SHEET_SUMMARY:
         return { ...state, balanceSheetSummary: payload };

      case REPORT_BALANCE_SHEET_VERTICAL:
         return { ...state, balanceSheetVertical: payload };

      case REPORT_PROFIT_LOSS_MONTHLY:
         return { ...state, ProfitLossMonthly: payload };

      case REPORT_STORE_STOCK:
         return { ...state, storeStock: payload };

      case REPORT_STORE_STOCK_FOR_RECEIVE:
         return { ...state, storeStockForReceive: payload };

      case REPORT_B2B_SALES:
         return { ...state, b2bSales: payload };

      case REPORT_B2CL_SALES:
         return { ...state, b2clSales: payload };

      case REPORT_B2CS_SALES:
         return { ...state, b2csSales: payload };

      case REPORT_CDNR_SALES:
         return { ...state, cdnrSales: payload };

      case REPORT_CDNUR_SALES:
         return { ...state, cdnurSales: payload };

      case REPORT_EXP_SALES:
         return { ...state, expSales: payload };

      case REPORT_EXEMP_SALES:
         return { ...state, exempSales: payload };

      case REPORT_HSNB2B_SALES:
         return { ...state, hsnB2BSales: payload };

      case REPORT_HSNB2C_SALES:
         return { ...state, hsnB2CSales: payload };

      case REPORT_DOC_SALES:
         return { ...state, docsSales: payload };

      case REPORT_GSTR3B:
         return { ...state, gstr3b: payload };

      case REPORT_FORMAT:
         return { ...state, reportFormat: payload };

      case UPDATE_REPORT_FORMAT:
         return {
            ...state,
            reportFormat: state.reportFormat.map((format) =>
               format.id === payload.id ? { ...format, ...payload } : format,
            ),
         };
      case ADD_REPORT_FORMAT:
         return {
            ...state,
            reportFormat: [...state.reportFormat, payload],
         };

      case DELETE_REPORT_FORMAT:
         return {
            ...state,
            reportFormat: state.reportFormat.filter((format) => format.id !== payload.id),
         };

      case REPORT_ALL_TRANSACTION:
         return {
            ...state,
            allTransaction: payload,
         };

      case GSTR_2AB2B_RECONCILATION:
         return { ...state, GSTR2AB2BReconcilation: payload };

      case REPORT_MILL_ISSUE_DETAIL:
         return { ...state, millIssueDetail: payload };

      case REPORT_GRAY_PURCHASE_DETAIL:
         return { ...state, grayPurchaseDetail: payload };

      default:
         return state;
   }
};

export default reducer;
